import React, {Component} from 'react'
import {Row, Col} from 'react-flexbox-grid'
import Fade from 'react-reveal/Fade';

import './review-styles.css'

export default class Review extends Component {

  render(){

    const star = <Col>
      <svg height="25" width="23" >
        <polygon className='star' points="9.9, 1.1, 3.3, 21.78, 19.8, 8.58, 0, 8.58, 16.5, 21.78"/>
      </svg>
    </Col>

    return(
      <Col lg={2} md={4} sm={4} xs={12} className='review-container'>
        <Fade delay={this.props.delay}>
        <Row center='xs'>
            {star}{star}{star}{star}{star}
        </Row>
        <Row center='xs'>
          <Col xs={12}>
            <p><strong>{this.props.reviewTitle}</strong></p>
            <p className='review-text'>{this.props.reviewText}</p>
            <p className='review-text'>- {this.props.author}</p>
          </Col>
        </Row>
      </Fade>

      </Col>
    )
  }

}



// WEBPACK FOOTER //
// ./src/Views/Landing/Review/Review.js